import { LevelBuilder } from './LevelBuilder';
import { TileType } from '../TileEditorTypes';

/**
 * Procedurally generates the "Welcome to Helix 2000" title map.
 * This is an example script for AI agents to learn how to use the LevelBuilder.
 */
export function generateWelcomeMap(): ReturnType<typeof LevelBuilder.prototype.build> {
  const level = LevelBuilder.create('welcome_map', 100, 60)
    .setName('Welcome to Helix 2000')
    .setBackground('#000022'); // Dark space/night background

  // 1. A solid floor so the player doesn't fall forever
  level.ground(0, 58, 100, TileType.STONE);

  // 2. Player spawn point on the floor, on the left side
  level.spawn(10, 57);

  // 3. Floating Terrain Text: "H E L I X"
  // Drawing large letters using floating platforms

  // 'H'
  level.wall(20, 30, 10, TileType.GRASS);
  level.wall(24, 30, 10, TileType.GRASS);
  level.platform(21, 35, 3, TileType.GRASS);

  // 'E'
  level.wall(28, 30, 10, TileType.ICE);
  level.platform(28, 30, 5, TileType.ICE);
  level.platform(28, 35, 4, TileType.ICE);
  level.platform(28, 39, 5, TileType.ICE);

  // 'L'
  level.wall(36, 30, 10, TileType.WOOD);
  level.platform(36, 39, 5, TileType.WOOD);

  // 'I'
  level.wall(44, 30, 10, TileType.STONE);

  // 'X' (Approximated with platforms/walls)
  // X is hard on a rigid grid without slopes, so we do a jagged X
  level.tile(50, 30, TileType.LAVA); level.tile(54, 30, TileType.LAVA);
  level.tile(51, 32, TileType.LAVA); level.tile(53, 32, TileType.LAVA);
  level.tile(52, 34, TileType.LAVA); // Center
  level.tile(51, 36, TileType.LAVA); level.tile(53, 36, TileType.LAVA);
  level.tile(50, 38, TileType.LAVA); level.tile(54, 38, TileType.LAVA);

  // 4. Floating Terrain Text: "2 0 0 0"

  // '2'
  level.platform(60, 30, 4, TileType.ICE);
  level.tile(63, 31, TileType.ICE);
  level.platform(60, 32, 4, TileType.ICE);
  level.tile(60, 33, TileType.ICE);
  level.platform(60, 34, 4, TileType.ICE);

  // '0'
  level.wall(66, 30, 5, TileType.ICE);
  level.wall(69, 30, 5, TileType.ICE);
  level.platform(67, 30, 2, TileType.ICE);
  level.platform(67, 34, 2, TileType.ICE);

  // '0'
  level.wall(72, 30, 5, TileType.ICE);
  level.wall(75, 30, 5, TileType.ICE);
  level.platform(73, 30, 2, TileType.ICE);
  level.platform(73, 34, 2, TileType.ICE);

  // '0'
  level.wall(78, 30, 5, TileType.ICE);
  level.wall(81, 30, 5, TileType.ICE);
  level.platform(79, 30, 2, TileType.ICE);
  level.platform(79, 34, 2, TileType.ICE);

  // 5. Some decorations below the text
  level.water(20, 50, 60, 3); // A large pool of water under the text

  // 6. An exit teleporter to the starter map
  level.teleporter(85, 57, 'starter_map');

  return level.build();
}
